var path = 'scripts/views/components/user-preferences.html';
var html = "<a class=\"user-preferences\" href=\"\" ng-click=\"$ctrl.openUserPreferencesModal()\">\n    <span class=\"user-full-name em-bold align-xs-left\">{{$ctrl.currentUser | fullName}}</span>\n    <span class=\"fa fa-gear\"></span>\n</a>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/main/resources/static/scripts/views/components/user-preferences.html
// module id = 371
// module chunks = 0